import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useStartCheckout } from './useStartCheckout';

export function useBasketDrawerActions() {
  const showContinueShopping = useFeatureIsOn('feature.basket-continue-shopping');
  const { startCheckout, isStartingCheckout } = useStartCheckout();

  return {
    showContinueShopping,
    onCheckout: startCheckout,
    isCheckoutLoading: isStartingCheckout,
  };
}
